import React from 'react'
import {
  formatVisitDateOrHour,
  formatMoney,
  safePercent,
  extractActiveRoles
} from '../../../helpers/utils'
import { createReportDetailsTab } from './createReportDetailsTab'

const HEADERS = [
  { label: 'CÓDIGO', description: 'Número de identificación del usuario' },
  { label: 'USUARIO', description: 'Nombre del usuario' },
  { label: 'ÚLTIMA ACTIVIDAD', description: 'Hora de última actividad registrada' },
  { label: 'VISITAS REALIZADAS', description: 'Cantidad total de visitas registradas' },
  { label: 'VISITAS FUERA DE RUTA', description: 'Visitas que no estaban asignadas' },
  { label: 'EFECTIVIDAD', description: 'Porcentaje de visitas efectivas sobre las realizadas' },
  {
    label: 'ACTIVIDADES DENTRO DE GEOCERCA',
    description: 'Actividades dentro de la zona permitida'
  },
  { label: 'TAREAS EN SITIO', description: 'Tareas realizadas vs asignadas en sitio' },
  { label: 'TOTAL DEVOLUCIONES', description: 'Monto total de devoluciones realizadas' },
  { label: 'TOTAL ENTREGAS', description: 'Monto total de entregas realizadas' },
  { label: 'TOTAL PEDIDOS', description: 'Monto total de pedidos realizados' }
]

function renderRow(model) {
  return (
    <>
      <td>{model.user_uid}</td>
      <td>{model.user_name}</td>
      <td className="text-center">{formatVisitDateOrHour(model.last_visit)}</td>
      <td className="text-center">
        {model.total_visited_clients}/{model.all_executed_clients}
      </td>
      <td className="text-center">{model.out_of_route_clients}</td>
      <td className="text-center">
        {safePercent(model.effective_clients, model.all_executed_clients)}%
      </td>
      <td className="text-center">
        {model.geofence_effective_clients_count}/{model.geofence_location_available_count}
      </td>
      <td className="text-center">
        {extractActiveRoles(model.user_active_roles).includes('pos_task_activity')
          ? `${model.pos_task_activity_done_task_codes_count}/${model.pos_task_activity_total_clients_count}`
          : 'N/A'}
      </td>
      <td className="text-center">{formatMoney(model.total_delivery)}</td>
      <td className="text-center">{formatMoney(model.total_refund)}</td>
      <td className="text-center">{formatMoney(model.total_order)}</td>
    </>
  )
}

export default createReportDetailsTab({
  displayName: 'ReportSummaryTab',
  headers: HEADERS,
  renderRow
})
